<div class="overflow-hidden rounded-t-xl w-full z-[9999]">
  <div class="relative">
    @if (popups().length > 1) {
      <div
        class="absolute z-10 top-2 right-4 text-white text-xs bg-black bg-opacity-50 px-2 py-1 rounded-xl"
      >
        <p>{{ realIndex() + 1 }} / {{ popups().length }}</p>
      </div>
    }
    <div
      swiper
      [options]="swiperOptions()"
      class="swiper"
      (realIndex)="realIndex.set($event)"
    >
      <div class="swiper-wrapper">
        @for (popup of popups(); track $index) {
          <div class="swiper-slide">
            <a
              [href]="popup?.linkUrl"
              target="_blank"
              [ngClass]="
                popup?.linkUrl ? 'hover:opacity-80 transition-all' : ''
              "
            >
              <img
                [src]="popup?.imageUrl"
                alt="popup image"
                class="w-full min-h-[50dvh] max-h-[50dvh]"
              />
            </a>
          </div>
        }
      </div>
    </div>
    <div
      class="flex items-center px-5 py-4 text-sm text-white bg-zinc-700"
      [ngClass]="
        popupSetting$.value()!.isShowTodayButton
          ? 'justify-between'
          : 'justify-end'
      "
    >
      @if (popupSetting$.value()!.isShowTodayButton) {
        <button (click)="handleNotToday(popupSetting$.value()!.type, $event)">
          오늘하루 그만보기
        </button>
      } @else {
        <div class="p-1"></div>
      }
      <button (click)="close($event)">닫기</button>
    </div>
  </div>
</div>
